import emailjs from '@emailjs/browser';

/**
 * Email Service using Email.js
 * Handles sending OTP emails for password reset and other authentication flows
 */

// Email.js Configuration loaded dynamically from env files
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY

/**
 * Send OTP email to user
 * @param {string} toEmail - Recipient email address
 * @param {string} otp - One-Time Password code
 * @param {string} userName - User's name (optional)
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const sendOTPEmail = async (toEmail, otp, userName = 'User') => {
  try {
    // Validate email
    if (!toEmail || !toEmail.trim()) {
      return {
        success: false,
        message: 'Recipient email address is required.',
      };
    }

    // Template parameters
    // Note: Email.js recipient is typically configured in the service settings
    // These variables are for the email template content
    const templateParams = {
      to_email: toEmail,
      user_email: toEmail, // Alternative variable name
      email: toEmail, // Another common variable name
      to_name: userName,
      user_name: userName,
      passcode: otp,
    };

    console.log('Sending OTP email to:', toEmail);
    console.log('Template params:', templateParams);

    // Send email using Email.js (following official docs pattern)
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      {
        publicKey: EMAILJS_PUBLIC_KEY,
      }
    );

    console.log('Email sent successfully:', response);

    return {
      success: true,
      message: 'OTP sent successfully to your email.',
    };
  } catch (error) {
    console.error('Failed to send OTP email:', error);

    // Handle specific error cases
    if (error.text) {
      return {
        success: false,
        message: `Failed to send email: ${error.text}`,
      };
    }

    return {
      success: false,
      message: 'Failed to send OTP email. Please try again.',
    };
  }
};

/**
 * Initialize Email.js (optional, for future use)
 */
export const initEmailJS = () => {
  emailjs.init(EMAILJS_PUBLIC_KEY);
  console.log('Email.js initialized');
};

const emailService = {
  sendOTPEmail,
  initEmailJS,
};

export default emailService;
